import { render, staticRenderFns } from "./MarkdownSelect.vue?vue&type=template&id=55ce110e&scoped=true"
import script from "./MarkdownSelect.vue?vue&type=script&lang=js"
export * from "./MarkdownSelect.vue?vue&type=script&lang=js"
import style0 from "./MarkdownSelect.vue?vue&type=style&index=0&id=55ce110e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55ce110e",
  null
  
)

export default component.exports